
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import appconst from '@/lib/appconst';
    import DateUtils from '@/common/js/DateUtils';

    @Component
    export default class MultiWeight extends Vue {
        @Prop({ type: Boolean, default: false }) value: boolean;
        mainLandPackageList: any[] = []; // 本土包裹列表
        selectedPackageId: number | null = null; // 选中的本土包裹ID
        orderInfo = {
            orderId: 0,
            orderNumber: '',
            baseSkuNums: 0
        };

        logisticsList: any[] = [];
        saving: boolean = false;

        // 图片预览
        previewModal: boolean = false;
        previewUrl: string = '';

        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };

        imgUploadUrl: string = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";

        // 判断是否所有快递都已称重
        get allWeighed(): boolean {
            // 增加非空判断，确保数组存在且所有项都已称重
            return this.logisticsList && this.logisticsList.length > 0
                && this.logisticsList.every(item => !!item.isWeighed);
        }

        // 判断是否可以称重
        canWeigh(item: any): boolean {
            return item.long && item.long > 0 &&
                item.wide && item.wide > 0 &&
                item.high && item.high > 0 &&
                item.weight && item.weight > 0;
        }

        // 计算重量
        calculateWeight(item: any, index: number) {
            // 计算体积重 (长*宽*高/6000 单位：g)
            if (item.long && item.long > 0 && item.wide && item.wide > 0 && item.high && item.high > 0) {
                item.bulkyByClient = Math.round(
                    item.long * item.wide * item.high / 6
                );
            }

            // 实重取重量值
            if (item.weight && item.weight > 0) {
                item.heavyWeight = item.weight;
            }

            // 计算运费
            this.calculateFreight(item, index);
        }

        async getMainLandPackageList() {
            if (!this.mainLandPackageList || this.mainLandPackageList.length == 0) {
                this.mainLandPackageList = await this.$store.dispatch({
                    type: 'mainlandpackage/getMainLandPackageList',
                    data: {}
                });
                if (this.mainLandPackageList.length == 0) {
                    this.$Modal.error({
                        title: "操作提示",
                        content: "请先创建本土包裹，再称重",
                        // 居中关键配置（iview Modal 已默认居中，以下是增强配置）
                        width: 400, // 自定义宽度
                        okText: "我知道了", // 自定义按钮文字
                        onOk: () => {
                            // 可选：关闭后的回调逻辑
                            console.log('用户已确认提示');
                        }
                    });
                    return;
                }
                if (this.mainLandPackageList.length == 1) {
                    this.selectedPackageId = this.mainLandPackageList[0].id;
                }
            }
        }
        // 计算运费
        async calculateFreight(item: any, index: number) {
            if (!item.long || !item.wide || !item.high || !item.weight) {
                return;
            }

            try {
                var data = {
                    long: item.long,
                    wide: item.wide,
                    high: item.high,
                    weight: item.weight,
                    bulkyByClient: item.bulkyByClient || 0
                };

                var result = await this.$store.dispatch({
                    type: 'backmainlandorder/calculateFreight',
                    data: data
                });

                if (result) {
                    item.freightCost = result.freightCost;
                    this.$set(this.logisticsList, index, item);
                }
            } catch (error) {
                console.error('计算运费失败', error);
            }
        }

        // 标记为已称重
        markAsWeighed(item: any, index: number) {
            if (!this.canWeigh(item)) {
                this.$Message.warning('请先填写完整的尺寸和重量信息');
                return;
            }

            item.isWeighed = true;
            item.isEditing = false;
            item.weighingTime = new Date();
            item.weighingUserId = abp.session.userId;
            this.$set(this.logisticsList, index, item);
            this.$Message.success('快递已标记为称重');
        }

        // 开始编辑（重新称重）
        startEdit(item: any, index: number) {
            // 保存原始数据，以便取消时恢复
            item.originalData = {
                long: item.long,
                wide: item.wide,
                high: item.high,
                weight: item.weight,
                heavyWeight: item.heavyWeight,
                bulkyByClient: item.bulkyByClient,
                freightCost: item.freightCost,
                weightImageUploadGuid: item.weightImageUploadGuid
            };
            item.isEditing = true;
            this.$set(this.logisticsList, index, item);
        }

        // 保存编辑
        async saveEdit(item: any, index: number) {
            if (!this.canWeigh(item)) {
                this.$Message.warning('请填写完整的尺寸和重量信息');
                return;
            }

            if (!this.selectedPackageId) {
                this.$Message.warning('请选择本土包裹');
                return;
            }

            // 准备保存数据
            var saveData = {
                orderId: this.orderInfo.orderId,
                logisticsInfoId: item.id,
                long: item.long,
                wide: item.wide,
                high: item.high,
                weight: item.weight,
                weightImageUploadGuid: item.weightImageUploadGuid,
                packId: this.selectedPackageId
            };

            try {
                // 调用后台保存单个快递称重信息
                await this.$store.dispatch({
                    type: 'backmainlandorder/saveSingleWeighingInfo',
                    data: saveData
                });

                // 更新本地状态
                item.isEditing = false;
                item.isWeighed = true;
                item.weighingTime = new Date();
                delete item.originalData;
                this.$set(this.logisticsList, index, item);

                this.$Message.success('修改已保存');
                this.$forceUpdate();
            } catch (error) {
                console.error('保存失败', error);
            }
        }

        // 取消编辑
        cancelEdit(item: any, index: number) {
            if (item.originalData) {
                item.long = item.originalData.long;
                item.wide = item.originalData.wide;
                item.high = item.originalData.high;
                item.weight = item.originalData.weight;
                item.heavyWeight = item.originalData.heavyWeight;
                item.bulkyByClient = item.originalData.bulkyByClient;
                item.freightCost = item.originalData.freightCost;
                item.weightImageUploadGuid = item.originalData.weightImageUploadGuid;
                delete item.originalData;
            }
            item.isEditing = false;
            this.$set(this.logisticsList, index, item);
        }

        // 图片上传成功
        handleImageSuccess(res: any, item: any) {
            if (res.success) {
                item.weightImageUploadGuid = res.result;
                this.$forceUpdate();
                this.$Message.success('图片上传成功');
            }
        }

        handleImageError(res: any) {
            var msg = '图片上传失败';
            if (res && res.message) {
                msg = res.message;
            }
            this.$Message.error(msg);
        }

        // 获取图片URL
        getImageUrl(guid: string) {
            if (!guid) return '';
            var data = { imageGuid: guid, url: null };
            this.$store.commit('backlogistics/getImgUrl', data);
            return data.url;
        }

        // 预览图片
        previewImage(item: any) {
            if (item.weightImageUploadGuid) {
                this.previewUrl = this.getImageUrl(item.weightImageUploadGuid);
                this.previewModal = true;
            }
        }

        // 保存所有称重数据
        //async saveAll() {
        //    this.saving = true;

        //    // 准备保存数据
        //    var logisticsData = [];
        //    for (var i = 0; i < this.logisticsList.length; i++) {
        //        var item = this.logisticsList[i];
        //        logisticsData.push({
        //            logisticsInfoId: item.id,
        //            long: item.long,
        //            wide: item.wide,
        //            high: item.high,
        //            weight: item.weight,
        //            heavyWeight: item.heavyWeight,
        //            bulkyByClient: item.bulkyByClient,
        //            freightCost: item.freightCost,
        //            weightImageUploadGuid: item.weightImageUploadGuid,
        //            weighingTime: item.weighingTime,
        //            weighingUserId: item.weighingUserId
        //        });
        //    }

        //    var saveData = {
        //        orderId: this.orderInfo.orderId,
        //        baseSkuNums: this.orderInfo.baseSkuNums,
        //        logisticsList: logisticsData
        //    };

        //    try {
        //        await this.$store.dispatch({
        //            type: 'backmainlandorder/batchSaveWeighing',
        //            data: saveData
        //        });

        //        this.$Message.success('称重数据保存成功');
        //        this.$emit('save-success');
        //        this.cancel();
        //    } catch (error) {
        //        console.error('保存失败', error);
        //    } finally {
        //        this.saving = false;
        //    }
        //}

        // 完成称重
        async completeWeighing() {
            if (!this.allWeighed) {
                this.$Message.warning('还有快递未完成称重');
                return;
            }

            if (!this.selectedPackageId) {
                this.$Message.warning('请选择本土包裹');
                return;
            }

            try {
                // 保存所有称重数据
           //     await this.saveAll();
                this.cancel();
                // 检查是否需要自动跳转
                const automaticJump = this.$store.state.backmainlandorder.automaticJump;
                if (automaticJump) {
                    var timestamp1 = (new Date()).valueOf().toString();
                    this.$router.push({
                        name: 'intoLogistics',
                        params: { JumpPage: timestamp1 }
                    });
                }
            } catch (error) {
                console.error('完成称重失败', error);
            }
        }

        // 取消
        cancel() {
            this.$emit('input', false);
        }

        // 模态框显示状态变化
        visibleChange(value: boolean) {
            if (value) {
                // 模态框打开时，直接初始化
                this.getMainLandPackageList();
                this.initData();
            } else {
                // 模态框关闭时，只清空本地数据
                this.logisticsList = [];
                this.selectedPackageId = null;
                // 不要清除 store 中的数据
                // this.$store.state.backmainlandorder.orderWeighingInfo = null;  // 删除这一行
            }
        }

        // 初始化数据
        initData() {
            var orderInfo = this.$store.state.backmainlandorder.orderWeighingInfo;

            if (!orderInfo) {
                this.$Message.warning('订单信息不存在');
                return;
            }

            this.orderInfo = {
                orderId: orderInfo.orderId,
                orderNumber: orderInfo.orderNumber,
                baseSkuNums: orderInfo.baseSkuNums || 0
            };

            this.logisticsList = [];

            setTimeout(() => {
                var list = [];
                for (var i = 0; i < orderInfo.logisticsList.length; i++) {
                    var item = orderInfo.logisticsList[i];
                    list.push({
                        id: item.logisticsInfoId,
                        shipment: item.shipment || '',
                        shelfNumber: item.shelfNumber || '',
                        long: item.long || null,
                        wide: item.wide || null,
                        high: item.high || null,
                        weight: item.weight || null,
                        heavyWeight: item.heavyWeight || null,
                        bulkyByClient: item.bulkyByClient || null,
                        freightCost: item.freightCost || 0,
                        weightImageUploadGuid: item.weightImageUploadGuid || '',
                        weighingTime: item.weighingTime || null,
                        isWeighed: !!(item.weighingTime || item.heavyWeight),
                        isEditing: false
                    });
                }
                this.logisticsList = list;
                this.$forceUpdate();
            }, 50);
        }

        created() {
          //  this.getMainLandPackageList();
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
        }
    }
